export default {"src":"/_next/static/media/multiple.d0b4d3fd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};